// extracted by mini-css-extract-plugin
export default {"swiperslide":"DaySelector_swiperslide__8KXSv","swiperStyles":"DaySelector_swiperStyles__w3VVn"};